import React, { Suspense, useCallback, useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { TostMsg } from "../../../App";
import { getTicketListData, addTicket, } from "./LeadService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import { MultiSelect } from "primereact/multiselect";
import moment from "moment";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";

function LeadManagementList() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [ticketData, setTicketData] = useState([]);
  const [ticketDataCount, setTicketDataCount] = useState([]);
  const [noData, setNoData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const selectedColumns = [
    "RequestTitle",
    "RequestNumber",
    "CreatedDate",
    "EmployeeFullName",
    "RequestStatus",
    "CategoryName",
    "SubCategoryName",
    "AssignToName",
    "Priority",
    "PriorityName",
    "Severity",
    "SeverityName",
  ];
  const [selectedTicket, setSelectedTicket] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [ticketStatusType, setTicketStatusType] = useState([]);
  const [ticketCategoryType, setTicketCategoryType] = useState([]);
  const [ticketSubcategoryType, setTicketSubcategoryType] = useState([]);
  const [ticketSubcategoryTypeSelected, setTicketSubcategoryTypeSelected] =
    useState([]);
  const [ticketPriorityType, setTicketPriorityType] = useState([]);
  const [ticketSeverityType, setTicketSeverityType] = useState([]);
  const [selectedTableStatus, setSelectedTableStatus] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedTableCategory, setSelectedTableCategory] = useState(null);
  const [selectedTableSubCategory, setSelectedTableSubCategory] =
    useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [selectedServerity, setSelectedServerity] = useState(null);
  const [filterStartDate, setFilterStartDate] = useState("02/01/2016");
  const [filterEndDate, setFilterEndDate] = useState("02/01/2029");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [selectedAssingToName, setSelectedAssingToName] = useState(null);
  const [employeDetails, setEmployeDetails] = useState([]);
  const [selectedRaiseBy, setSelectedRaiseBy] = useState(null);
  const [ticketDataMessage, setTicketDataMessage] = useState("");
  const [userUpdatePermission, setUserUpdatePermission] = useState(false);
  const [userAddPermission, setUserAddPermission] = useState(false);

const dummyLeadData = [
  {
    LeadId: 101,
    LeadName: "Mithlesh Yadav",
    Company: "TechNova Solutions",
    LeadSource: "Website",
    NextAction: "Follow-up Call",
    NextActionDate: "2026-02-05",
    LastContactedDate: "2026-01-28",
    LastInteractionType: "Call",
    Notes: "Interested in enterprise CRM solution",
    ServiceType: "CRM",
    DealTitle: "CRM Implementation – TechNova",
    DealStage: "Negotiation",
    LeadStage: "Hot",
    Probability: 85,
    DealHealth: "Green",
    ExpectedDealValueINR: 850000,
    ExpectedDealValueUSD: 10200,
    AssignedToName: "Rahul Verma",
    LastUpdatedBy: "Admin",
    LastUpdatedDate: "2026-01-29",
    LeadCreationDate: "2026-01-10",
    CloseRemarks: "",
    OwnerName: "North India Sales",
    LeadTags: "Enterprise,CRM,Priority",
    Email: "amit.sharma@technova.com",
    Phone: "+91 9876543210",
    Website: "https://technova.com",
    City: "Delhi",
    Address: "Connaught Place",
    Country: "India",
    DOB: "1991-03-12",
    AnniversaryDate: "2017-11-18",
  },
  {
    LeadId: 102,
    LeadName: "Dharmesh Tyagi",
    Company: "BrightEdge Inc",
    LeadSource: "Referral",
    NextAction: "Send Proposal",
    NextActionDate: "2026-02-08",
    LastContactedDate: "2026-01-30",
    LastInteractionType: "Email",
    Notes: "Looking for ERP + Support package",
    ServiceType: "ERP",
    DealTitle: "ERP Rollout – BrightEdge",
    DealStage: "Proposal",
    LeadStage: "Warm",
    Probability: 65,
    DealHealth: "Amber",
    ExpectedDealValueINR: 1250000,
    ExpectedDealValueUSD: 15000,
    AssignedToName: "Sophia Martin",
    LastUpdatedBy: "Sophia Martin",
    LastUpdatedDate: "2026-01-30",
    LeadCreationDate: "2026-01-14",
    CloseRemarks: "",
    OwnerName: "US Sales Team",
    LeadTags: "ERP,MidMarket",
    Email: "emily.watson@brightedge.com",
    Phone: "+1 415 889 2211",
    Website: "https://brightedge.com",
    City: "San Francisco",
    Address: "Market Street",
    Country: "USA",
    DOB: "1989-08-25",
    AnniversaryDate: "2015-05-14",
  },
  {
    LeadId: 103,
    LeadName: "Amir Khan",
    Company: "DesertTech LLC",
    LeadSource: "LinkedIn",
    NextAction: "Product Demo",
    NextActionDate: "2026-02-12",
    LastContactedDate: "2026-02-01",
    LastInteractionType: "Meeting",
    Notes: "Needs custom integration discussion",
    ServiceType: "Custom Software",
    DealTitle: "Custom CRM – DesertTech",
    DealStage: "Qualification",
    LeadStage: "Cold",
    Probability: 40,
    DealHealth: "Red",
    ExpectedDealValueINR: 420000,
    ExpectedDealValueUSD: 5000,
    AssignedToName: "Imran Ali",
    LastUpdatedBy: "Imran Ali",
    LastUpdatedDate: "2026-02-01",
    LeadCreationDate: "2026-01-20",
    CloseRemarks: "",
    OwnerName: "Middle East Sales",
    LeadTags: "Custom,Integration",
    Email: "mohammed.khan@deserttech.ae",
    Phone: "+971 50 778 9921",
    Website: "https://deserttech.ae",
    City: "Dubai",
    Address: "Business Bay",
    Country: "UAE",
    DOB: "1990-12-05",
    AnniversaryDate: "2018-09-22",
  },
];



  useEffect(() => {
    GetMasterSystemAlertList("Ticket_Unavailable", 2);
    getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    fetchEmployeeIdData();
    permissionAccouncementList();
    getMasterTicketStatus();
    getMasterTicketCategory();
    getMasterTicketSubCategory();
    getMasterTicketPriority();
    getMasterTicketSeverity();
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Ticket.Update") {
        setUserUpdatePermission(true);
      } else if (UserPermission.PermissionName == "Ticket.Add") {
        setUserAddPermission(true);
      }
    });
  };

  // async function getTicketData(pageNumber, pageSize, debouncedSearchTerm) {
  //   setTicketDataMessage("Loding...");
  //   const searchStatusValue = selectedTableStatus
  //     ?.map((emp) => emp.Id)
  //     .join(",");
  //   const searchCategoryValue = selectedTableCategory
  //     ?.map((emp) => emp.Id)
  //     .join(",");
  //   const searchSubCategoryValue = selectedTableSubCategory
  //     ?.map((emp) => emp.Id)
  //     .join(",");
  //   const searchPriorityValue = selectedPriority
  //     ?.map((emp) => emp.Id)
  //     .join(",");
  //   const searchSeverityName = selectedServerity
  //     ?.map((emp) => emp.Id)
  //     .join(",");
  //   const searchAssingToName = selectedAssingToName
  //     ?.map((emp) => emp.Id)
  //     .join(",");
  //   const searchRaiseBy = selectedRaiseBy?.map((emp) => emp.Id).join(",");
  //   let serchTitle;
  //   let searchStartDate;
  //   let searchEndDate;

  //   if (debouncedSearchTerm?.requestTitle) {
  //     serchTitle = debouncedSearchTerm?.requestTitle;
  //   } else if (debouncedSearchTerm?.CreatedDate) {
  //     searchStartDate = debouncedSearchTerm?.CreatedDate;
  //   } else if (debouncedSearchTerm?.EndDate) {
  //     searchEndDate = debouncedSearchTerm?.EndDate;
  //   }
  //   setIsloading(true);
  //   const params = {
  //     OrgId: userDetails?.OrgId,
  //     LoggedInEmpId: userDetails?.EmpId,
  //     RaisedByEmpId: searchRaiseBy ?? "",
  //     AssignedToId: searchAssingToName ?? "",
  //     TicketId: 0,
  //     RequestStatusId: searchStatusValue ?? "",
  //     RequestCategoryId: searchCategoryValue ?? "",
  //     RequestSubCategoryId: searchSubCategoryValue ?? "",
  //     PriorityId: searchPriorityValue ?? "",
  //     SeverityId: searchSeverityName ?? "",
  //     Search: serchTitle ? serchTitle : "",
  //     filterStartDate: searchStartDate ? searchStartDate : filterStartDate,
  //     filterEndDate: searchEndDate ? searchEndDate : filterEndDate,
  //     PageNumber: pageNumber + 1,
  //     PageSize: pageSize,
  //     IsDeleted: 0,
  //     RequestNumber: "",
  //   };

  //   try {
  //     const data = await getTicketListData(params);
  //     setIsloading(true);
  //     let ticketDetailData = await data;
  //     var romoveDuplicateData = ticketDetailData?.Data?.OrgLeads?.reduce(
  //       (unique, o) => {
  //         if (!unique?.some((obj) => obj.Id === o.Id)) {
  //           unique.push(o);
  //         }
  //         return unique;
  //       },
  //       []
  //     );
  //     // setTicketData(romoveDuplicateData);
  //     if (romoveDuplicateData && romoveDuplicateData.length > 0) {
  //       setTicketData(romoveDuplicateData);
  //     } else {
  //       setTicketData(dummyLeadData);
  //       setTotalRecords(dummyLeadData.length);
  //     }

  //     setTicketDataCount(ticketDetailData?.Data?.LeadStatusCounts);
  //     setTotalRecords(ticketDetailData?.Data?.TotalLeadcount);
  //     setIsloading(false);
  //   }
  //   // catch {
  //   //   setIsloading(false);
  //   //   toster.error("Something went wrong");
  //   // } 
  //   catch {
  //     setIsloading(false);
  //     setTicketData(dummyLeadData);
  //     setTotalRecords(dummyLeadData.length);
  //     toster.error("Showing demo data (API unavailable)");
  //   }

  //   finally {
  //     if (romoveDuplicateData?.length === 0) {
  //       setTicketDataMessage("NO DATA FOUND.");
  //     }
  //   }
  // }

  async function getTicketData(pageNumber, pageSize, debouncedSearchTerm) {
    setTicketDataMessage("Loading...");
    setIsloading(true);

    let romoveDuplicateData = [];

    try {
      const params = {
        OrgId: userDetails?.OrgId,
        LoggedInEmpId: userDetails?.EmpId,
        RaisedByEmpId: selectedRaiseBy?.map((e) => e.Id).join(",") ?? "",
        AssignedToId: selectedAssingToName?.map((e) => e.Id).join(",") ?? "",
        TicketId: 0,
        RequestStatusId: selectedTableStatus?.map((e) => e.Id).join(",") ?? "",
        RequestCategoryId: selectedTableCategory?.map((e) => e.Id).join(",") ?? "",
        RequestSubCategoryId:
          selectedTableSubCategory?.map((e) => e.Id).join(",") ?? "",
        PriorityId: selectedPriority?.map((e) => e.Id).join(",") ?? "",
        SeverityId: selectedServerity?.map((e) => e.Id).join(",") ?? "",
        Search: debouncedSearchTerm?.requestTitle ?? "",
        filterStartDate,
        filterEndDate,
        PageNumber: pageNumber + 1,
        PageSize: pageSize,
        IsDeleted: 0,
        RequestNumber: "",
      };

      const res = await getTicketListData(params);

      romoveDuplicateData =
        res?.Data?.OrgLeads?.reduce((unique, o) => {
          if (!unique.some((obj) => obj.LeadId === o.LeadId)) {
            unique.push(o);
          }
          return unique;
        }, []) || [];

      if (romoveDuplicateData.length > 0) {
        setTicketData(dummyLeadData);
        setTotalRecords(res?.Data?.TotalLeadcount || romoveDuplicateData.length);
      } else {
        // ✅ EMPTY API RESPONSE → SHOW DUMMY DATA
        setTicketData(dummyLeadData);
        setTotalRecords(dummyLeadData.length);
        setTicketDataMessage("Showing demo data");
      }

      setTicketDataCount(res?.Data?.LeadStatusCounts || []);
    } catch (error) {
      // ✅ API FAILURE → SHOW DUMMY DATA
      setTicketData(dummyLeadData);
      setTotalRecords(dummyLeadData.length);
      setTicketDataMessage("Showing demo data (API unavailable)");
      toster.error("API unavailable – showing demo data");
    } finally {
      setIsloading(false);
    }
  }


  const onPageChange = (e) => {
    setCurrentPage(e.page);
    setRowsPerPage(e.rows);
    getTicketData(e.page, e.rows, debouncedSearchTerm);
  };

  async function GetMasterSystemAlertList(message, type) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }

  const requestTitle = (rowData) => {
    const maxLength = 25;
    const truncatedTitle =
      rowData.RequestTitle?.length > maxLength
        ? `${rowData.RequestTitle?.substring(0, maxLength)}...`
        : rowData.RequestTitle;

    if (
      userDetails?.EmpId === rowData?.AssignedToId &&
      userUpdatePermission === false
    ) {
      return (
        <div className="d-flex align-items-center">
          <Link
            to={`/Lead/Detail/${rowData.RequestNumber}`}
            title={rowData.RequestTitle}
            className="editbtncss me-2"
          >
            {truncatedTitle}
          </Link>
          <a
            href={`/Lead/Detail/${rowData.RequestNumber}`}
            title={rowData.RequestTitle}
            target="_blank"
            rel="noopener noreferrer"
            className="redirect"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-external-link"
              style={{ cursor: "pointer" }}
            >
              <path d="M18 3h3v3"></path>
              <path d="M10 14L21 3"></path>
              <path d="M21 10v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h11"></path>
            </svg>
          </a>
        </div>
      );
    } else if (
      userDetails?.EmpId === rowData?.AssignedToId ||
      userUpdatePermission === true
    ) {
      return (
        <div className="d-flex">
          <Link
            to={`/Lead/Detail/${rowData.RequestNumber}`}
            title={rowData.RequestTitle}
            className="editbtncss"
          >
            {truncatedTitle}
          </Link>
          <a
            href={`/Lead/Detail/${rowData.RequestNumber}`}
            title={rowData.RequestTitle}
            target="_blank"
            rel="noopener noreferrer"
            className="redirect"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-external-link"
              style={{ cursor: "pointer" }}
            >
              <path d="M18 3h3v3"></path>
              <path d="M10 14L21 3"></path>
              <path d="M21 10v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h11"></path>
            </svg>
          </a>
        </div>
      );
    } else {
      return (
        <div className="d-flex">
          <div title={rowData.RequestTitle} className="editbtncss">
            {truncatedTitle}
          </div>
        </div>
      );
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const nameBodyTemplate = (rowData) => {
    return (
      <Link to={`/Profile/${rowData.EmployeeUserGUID}`}>
        <div className="d-flex">
          <img
            src={rowData?.EmployeeProfileImage || defaultImage}
            onError={handleImageError}
            className="rounded-lg me-2"
            width="18"
            alt=""
          />{" "}
          <span className="w-space-no">{rowData?.EmployeeFullName}</span>
        </div>
      </Link>
    );
  };

  const assignBodyTemplate = (rowData) => {
    if (rowData.AssignedToId != 0) {
      return (
        <Link to={`/Profile/${rowData.AssignToUserGUID}`}>
          <div className="d-flex">
            <img
              src={rowData?.AssignToProfileImage || defaultImage}
              onError={handleImageError}
              className="rounded-lg me-2"
              width="18"
              alt=""
            />{" "}
            <span className="w-space-no">{rowData?.AssignToName}</span>
          </div>
        </Link>
      );
    }
    return <span>Not Assigned</span>;
  };

  const serverityContent = (rowData) => {
    return (
      <span>
        {rowData?.SeverityName == "Low" && <span className="low-pri">Low</span>}
        {rowData?.SeverityName == "Medium" && (
          <span className="med-pri">Medium</span>
        )}
        {rowData?.SeverityName == "High" && (
          <span className="high-pri">High</span>
        )}
      </span>
    );
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleInputChange = (e) => {
    const empIdsString = e?.value?.map((emp) => emp.Id).join(",");
    let { name, value } = e.target;
    if (empIdsString) {
      value = empIdsString;
    }
    if (name == "CreatedDate") {
      setStartDate(value);
      let startDate = formatDate(value);
      value = startDate;
      setFilterStartDate(value);
    } else if (name == "EndDate") {
      setEndDate(value);
      let endDate = formatDate(value);
      value = endDate;
      setFilterEndDate(formatDate(value));
    }
    setSearchTerm({ [name]: value });
  };

  const onSelectionChange = (event) => {
    const selectedValues = filterColumns(event.value);
    setSelectedTicket(selectedValues);
    const startIndex = currentPage * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const visibleRows = ticketData.slice(startIndex, endIndex);
    setSelectAll(selectedValues.length === visibleRows.length);
  };

  const onSelectAllChange = (event) => {
    const isChecked = event.checked;
    const startIndex = currentPage * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const visibleRows = filterColumns(ticketData.slice(startIndex, endIndex));

    if (isChecked) {
      setSelectAll(true);
      setSelectedTicket([...selectedTicket, ...visibleRows]);
    } else {
      setSelectAll(false);
      const updatedSelection = selectedTicket.filter(
        (ticket) => !visibleRows?.some((row) => row.TicketNO === ticket.TicketNO)
      );
      setSelectedTicket(updatedSelection);
    }
  };

  const filterColumns = (data) => {
    return data.map((item) =>
      selectedColumns.reduce((obj, key) => {
        if (item[key] !== undefined) {
          obj[key] = item[key];
        }
        return obj;
      }, {})
    );
  };

  async function fetchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    setIsloading(true);
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeDetails(employeesList.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const toggleFilterVisibility = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  function exportToCSV() {
    if (selectedTicket.length > 0) {
      const csv = Papa.unparse(selectedTicket);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "Tickets.csv");
    } else {
      toster.current.warn("Please select at least one employee");
    }
  }

  async function getMasterTicketStatus() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "TicketStatusType",
    };
    try {
      const data = await GetMasterTypeData(params);
      const sortedStatusData = data?.Data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setTicketStatusType(sortedStatusData);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Category",
    };
    try {
      const data = await GetMasterTypeData(params);
      const sortedCategoryData = data?.Data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setTicketCategoryType(sortedCategoryData);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSubCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Subcategory",
    };
    try {
      const data = await GetMasterTypeData(params);
      const sortedSubcategoryData = data?.Data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setTicketSubcategoryType(sortedSubcategoryData);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketPriority() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Priority",
    };
    try {
      const data = await GetMasterTypeData(params);
      const sortedPriorityData = data?.Data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setTicketPriorityType(sortedPriorityData);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSeverity() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Severity",
    };
    try {
      const data = await GetMasterTypeData(params);
      const sortedSeverityData = data?.Data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setTicketSeverityType(sortedSeverityData);
    } catch (error) {
      setIsloading(false);
    }
  }

  const onRowEditComplete = async (e) => {
    setIsloading(true);
    const priorityObject = ticketPriorityType.find(
      (priority) => priority.Name === e.newData?.PriorityName
    );
    const severityObject = ticketSeverityType.find(
      (priority) => priority.Name === e.newData?.SeverityName
    );
    const categoryObject = ticketCategoryType.find(
      (priority) => priority.Name === e.newData?.CategoryName
    );
    const subCategoryObject = ticketSubcategoryTypeSelected.find(
      (priority) => priority.Name === e.newData?.SubCategoryName
    );
    const requestStatus = ticketStatusType.find(
      (staus) => staus.Name === e.newData?.RequestStatus
    );
    const assignTo = employeDetails.find(
      (name) => name.FullName === e.newData?.AssignToName
    );
    let params = {
      Id: e.data?.Id,
      OrgId: e.data?.OrgId,
      EmpId: e.data?.EmpId,
      RequestTitle: e.data?.RequestTitle,
      RequestDescription: e.data?.RequestDescription,
      RequestCategoryId: Number(categoryObject ? categoryObject.Id : null),
      RequestSubCategoryId: Number(
        subCategoryObject ? subCategoryObject.Id : e.data?.RequestSubCategoryId
      ),
      Comment: e.newData?.Comment,
      Severity: Number(severityObject ? severityObject.Id : null),
      Priority: Number(priorityObject ? priorityObject.Id : null),
      AssignedToId: Number(assignTo ? assignTo.EmpId : null),
      RequestStatusId: Number(requestStatus ? requestStatus.Id : null),
    };
    try {
      await addTicket(params);
      GetMasterSystemAlertList("Ticket_Updated");
      setEditTicketId(0);
      getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    } catch (error) {
      setIsloading(false);
      toster.current.errpr("Something went wrong.");
    }
  };

  const priorityEditor = (options) => {
    return (
      <Dropdown
        value={ticketPriorityType.find(
          (priority) => priority.Name == options.value
        )}
        onChange={(e) => options.editorCallback(e.value.Name)}
        options={ticketPriorityType}
        optionLabel="Name"
        placeholder="Priority"
        className="w-full md:w-14rem"
      />
    );
  };

  const serverityEditor = (options) => {
    return (
      <Dropdown
        value={ticketSeverityType.find(
          (serverity) => serverity.Name == options.value
        )}
        onChange={(e) => options.editorCallback(e.value.Name)}
        options={ticketSeverityType}
        optionLabel="Name"
        placeholder="Serverity"
        className="w-full md:w-14rem"
      />
    );
  };

  const [editTicketId, setEditTicketId] = useState(0);
  const onRowEditInit = async (e) => {
    setEditTicketId(e.data.Id);
  };

  const categoryEditor = (options) => {
    let categoryId = ticketCategoryType.find(
      (catName) => catName.Name == options.value
    );
    if (categoryId) {
      setSelectedCategory(categoryId);
      let seletedSubCat = ticketSubcategoryType.filter((item) => {
        return item.CategoryId === categoryId.Id;
      });
      setTicketSubcategoryTypeSelected(seletedSubCat);
    }

    return (
      <Dropdown
        value={ticketCategoryType.find(
          (category) => category.Name == options.value
        )}
        onChange={(e) => {
          options.editorCallback(e.value.Name);
          const filtered = ticketSubcategoryType.filter(
            (item) => item.CategoryId === e.value.Id
          );
          setTicketSubcategoryTypeSelected(filtered);
          setTicketData((prev) =>
            prev.map((row) =>
              row.Id === editTicketId ? { ...row, SubCategoryName: "" } : row
            )
          );
        }}
        options={ticketCategoryType}
        optionLabel="Name"
        placeholder="Category"
        className="w-full md:w-14rem"
      />
    );
  };

  const subCategoryEditor = (options) => {
    return (
      <Dropdown
        value={ticketSubcategoryTypeSelected.find(
          (subCategory) => subCategory.Name == options.value
        )}
        onChange={(e) => {
          options.editorCallback(e.value.Name);
          setTicketData((prev) =>
            prev.map((row) =>
              row.Id === editTicketId
                ? { ...row, SubCategoryName: e.value.Name }
                : row
            )
          );
        }}
        options={ticketSubcategoryTypeSelected}
        optionLabel="Name"
        placeholder="SubCategory"
        className="w-full md:w-14rem"
      />
    );
  };

  const requestStatusEditor = (options) => {
    return (
      <Dropdown
        value={ticketStatusType.find((status) => status.Name == options.value)}
        onChange={(e) => options.editorCallback(e.value.Name)}
        options={ticketStatusType}
        optionLabel="Name"
        placeholder="Status"
        className="w-full md:w-14rem"
      />
    );
  };

  const assignToEditor = (options) => {
    return (
      <Dropdown
        value={employeDetails.find((name) => name.FullName == options.value)}
        onChange={(e) => options.editorCallback(e.value.FullName)}
        options={employeDetails}
        optionLabel="FullName"
        placeholder="Assign"
        itemTemplate={employeeOptionTemplate}
        filter
        className="w-full md:w-14rem"
      />
    );
  };

  const RaiseByEditor = (options) => {
    return (
      <div className="d-flex">
        <span className="w-space-no">{options.value}</span>
      </div>
    );
  };

  const RequestTitleEditor = (options) => {
    return (
      <div className="d-flex">
        <span className="w-space-no">{options.value}</span>
      </div>
    );
  };

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
        <span>{option.FullName}</span>
      </div>
    );
  };

  useEffect(() => {
    let categoryId = selectedCategory?.Id
      ? selectedCategory.Id
      : selectedCategory;
    if (selectedCategory) {
      let seletedSubCat = ticketSubcategoryType.filter(
        (item) => item.CategoryId === categoryId
      );
      setTicketSubcategoryTypeSelected(seletedSubCat);
    }
  }, [selectedCategory]);

  useEffect(() => {
    const filtered = ticketSubcategoryType?.filter((sub) =>
      selectedTableCategory?.some((sel) => sel.Id === sub.CategoryId)
    );
    setTicketSubcategoryTypeSelected(filtered);
  }, [selectedTableCategory]);

  useEffect(() => {
    if (selectedAssingToName?.EmpId) {
      getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    } else if (selectedRaiseBy?.EmpId) {
      getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    } else if (selectedRaiseBy == "") {
      getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    } else if (debouncedSearchTerm) {
      getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    }
  }, [
    currentPage,
    rowsPerPage,
    debouncedSearchTerm,
    selectedAssingToName,
    selectedRaiseBy,
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Lead Management</h2>
              </div>
              {userAddPermission && (
                <div className="rightside-tabs">
                  <Link
                    to="/MyLeads"
                    className="button h-button is-primary is-raised is-bold addd-ticket"
                  >
                    <span>My Leads</span>
                  </Link>
                  <Link to="/AddLead">
                    <button className="add-newticket w-auto float-right ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-plus"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                      </svg>{" "}
                      Add Lead
                    </button>
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-12">
            <div className="page-content-inner all-projects">
              <div className="tickets-summary">
                {ticketDataCount?.map((count, index) => (
                  <div className="column" key={index}>
                    <img src="images/org-img/leave/popup-backimg.png" />
                    <a>
                      <span>{count?.LeadCount ?? 0}</span>
                      <div>
                        <p>{count?.Status}</p>
                      </div>
                    </a>
                    <div className="progress">
                      <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{ width: "25%" }}
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="tabs-filters">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button class="nav-link active" id="nav-activity-view-tab" data-bs-toggle="tab" data-bs-target="#nav-activity-view" type="button" role="tab" aria-controls="nav-activity-view" aria-selected="true">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Activity View</span>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                      </svg>
                    </span>
                  </div>
                </button>
                <button class="nav-link" id="nav-latest-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-latest-contact" type="button" role="tab" aria-controls="nav-latest-contact" aria-selected="false">
                  <div className="d-flex justify-content-between align-items-center">
                    <span> Latest Contact</span>
                    {/* <span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                          </svg>
                          </span> */}
                  </div>

                </button>
                <button class="nav-link" id="nav-all-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-all-contact" type="button" role="tab" aria-controls="nav-all-contact" aria-selected="false">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>All Contact</span>
                    {/* <span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                          </svg>
                          </span> */}
                  </div>

                </button>
              </div>
            </nav>
          </div>
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-activity-view" role="tabpanel" aria-labelledby="nav-activity-view-tab">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">

                    <div className="form-head d-flex flex-wrap align-items-center mb-3">
                      <div className="me-auto w-20">
                        <strong
                          className="ticket-title m-0"
                          style={{ fontWeight: "bolder" }}
                        >
                          Leads ({totalRecords})
                        </strong>
                      </div>
                      <div className="actionbutton-tickets">
                        <InputText
                          name="requestTitle"
                          className="form-control mr-2"
                          placeholder="Search"
                          onChange={handleInputChange}
                        />
                        <button
                          className="export-btn"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Export"
                          onClick={() => exportToCSV()}
                        >
                          <img
                            src="/images/excels.png"
                            alt="export"
                            style={{ width: "21px" }}
                          />
                        </button>
                      </div>
                    </div>
                    <div className="form-head d-flex flex-wrap align-items-center bottom-head">
                      <div className="saving-btn00 d-flex w-100">
                        <div className="d-flex d-flexx">
                          <MultiSelect
                            name="assignToName"
                            className="w-full md:w-14rem"
                            value={selectedAssingToName}
                            onChange={(e) => {
                              setSelectedAssingToName(e.value);
                              handleInputChange(e);
                            }}
                            options={employeDetails}
                            optionLabel="FullName"
                            filter
                            placeholder="Assign To"
                            maxSelectedLabels={3}
                            selectedItemsLabel="{0} Assign to selected"
                            itemTemplate={employeeOptionTemplate}
                          />
                          {/* <Dropdown
                                  name="assignToName"
                                  className="w-full md:w-14rem"
                                  value={selectedAssingToName}
                                  onChange={(e) => {
                                    setSelectedAssingToName(e.value);
                                    handleInputChange(e);
                                  }}
                                  options={employeDetails?.toSpliced(0, 0, {
                                    id: 0,
                                    FullName: "All",
                                  })}
                                  itemTemplate={employeeOptionTemplate}
                                  filter
                                  optionLabel="FullName"
                                  placeholder="Assign To"
                                /> */}
                          <MultiSelect
                            name="assignToName"
                            className="w-full md:w-14rem"
                            value={selectedRaiseBy}
                            onChange={(e) => {
                              setSelectedRaiseBy(e.value);
                              handleInputChange(e);
                            }}
                            options={employeDetails}
                            optionLabel="FullName"
                            filter
                            placeholder="Raise By"
                            maxSelectedLabels={3}
                            selectedItemsLabel="{0} Raise by selected"
                            itemTemplate={employeeOptionTemplate}
                          />
                          {/* <Dropdown
                                  name="fullName"
                                  className="w-full md:w-14rem"
                                  value={selectedRaiseBy}
                                  onChange={(e) => {
                                    setSelectedRaiseBy(e.value);
                                    handleInputChange(e);
                                  }}
                                  options={employeDetails?.toSpliced(0, 0, {
                                    id: 0,
                                    FullName: "All",
                                  })}
                                  itemTemplate={employeeOptionTemplate}
                                  filter
                                  optionLabel="FullName"
                                  placeholder="Raise By"
                                /> */}
                          <MultiSelect
                            name="requestStatus"
                            value={selectedTableStatus}
                            onChange={(e) => {
                              setSelectedTableStatus(e.value);
                              handleInputChange(e);
                            }}
                            options={ticketStatusType}
                            optionLabel="Name"
                            filter
                            maxSelectedLabels={3}
                            selectedItemsLabel="{0} Status selected"
                            placeholder="Status"
                            className="w-full md:w-14rem"
                          />
                          <MultiSelect
                            name="CategoryName"
                            value={selectedTableCategory}
                            onChange={(e) => {
                              setSelectedTableCategory(e.value);
                              handleInputChange(e);
                            }}
                            options={ticketCategoryType}
                            optionLabel="Name"
                            filter
                            maxSelectedLabels={3}
                            selectedItemsLabel="{0} Category selected"
                            className="w-full md:w-14rem"
                            placeholder="Category"
                          />
                          <MultiSelect
                            disabled={!selectedTableCategory}
                            name="subCategory"
                            value={selectedTableSubCategory}
                            onChange={(e) => {
                              setSelectedTableSubCategory(e.value);
                              handleInputChange(e);
                            }}
                            options={ticketSubcategoryTypeSelected}
                            optionLabel="Name"
                            filter
                            maxSelectedLabels={3}
                            selectedItemsLabel="{0} Sub category selected"
                            className="w-full md:w-14rem"
                            placeholder="Sub Category"
                          />
                          <MultiSelect
                            name="priority"
                            value={selectedPriority}
                            onChange={(e) => {
                              setSelectedPriority(e.value);
                              handleInputChange(e);
                            }}
                            options={ticketPriorityType}
                            optionLabel="Name"
                            filter
                            maxSelectedLabels={3}
                            selectedItemsLabel="{0} Priority selected"
                            className="w-full md:w-14rem"
                            placeholder="Priority"
                          />

                          <MultiSelect
                            name="SeverityName"
                            value={selectedServerity}
                            onChange={(e) => {
                              setSelectedServerity(e.value);
                              handleInputChange(e);
                            }}
                            options={ticketSeverityType}
                            optionLabel="Name"
                            filter
                            maxSelectedLabels={3}
                            selectedItemsLabel="{0} Serverity selected"
                            className="w-full md:w-14rem"
                            placeholder="Serverity"
                          />
                          <span className="startdatefilter">Start Date</span>
                          <InputText
                            type="date"
                            name="CreatedDate"
                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                            placeholder="Date"
                            className="form-control mr-2"
                            value={startDate}
                            onChange={handleInputChange}
                          />
                          <span className="enddatefilter">End Date</span>
                          <InputText
                            type="date"
                            name="EndDate"
                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                            placeholder="Date"
                            className="form-control mr-2"
                            value={endDate}
                            onChange={handleInputChange}
                            min={startDate}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="table table-bordered dataTable no-footer tickettable">
                        <DataTable
                          value={ticketData}
                          paginator
                          rows={rowsPerPage}
                          first={currentPage * rowsPerPage}
                          totalRecords={totalRecords}
                          lazy
                          onPage={onPageChange}
                          dataKey="LeadId"
                          className="ticket-datatable"
                        >
                          <Column selectionMode="multiple" />

                          <Column field="LeadId" header="Lead ID" sortable />

                          <Column
                            field="LeadName"
                            header="Lead Name"
                            // body={requestTitle}   // keeps your context menu logic
                            sortable
                          />

                          <Column field="Company" header="Company" sortable />
                          <Column field="LeadSource" header="Lead Source" sortable />
                          <Column field="NextAction" header="Next Action" />
                          <Column field="NextActionDate" header="Next Action Date" body={(r) => moment(r.NextActionDate).format("DD MMM YYYY")} />
                          <Column field="LastContactedDate" header="Last Contacted Date" body={(r) => moment(r.LastContactedDate).format("DD MMM YYYY")} />
                          <Column field="LastInteractionType" header="Last Interaction Type" />
                          <Column field="Notes" header="Notes" />

                          <Column field="ServiceType" header="Service Type" />
                          <Column field="DealTitle" header="Deal Title" />
                          <Column field="DealStage" header="Deal Stage" />
                          <Column field="LeadStage" header="Lead Stage" />
                          <Column field="Probability" header="Probability %" />

                          <Column
                            field="DealHealth"
                            header="Deal Health"
                            body={(row) => (
                              <span className={
                                row.DealHealth === "Green" ? "badge bg-success" :
                                  row.DealHealth === "Amber" ? "badge bg-warning" :
                                    "badge bg-danger"
                              }>
                                {row.DealHealth}
                              </span>
                            )}
                          />

                          <Column field="ExpectedDealValueINR" header="Exp Deal Value (₹)" />
                          <Column field="ExpectedDealValueUSD" header="Exp Deal Value ($)" />

                          <Column field="AssignedToName" header="Assigned To" body={assignBodyTemplate} />
                          <Column field="LastUpdatedBy" header="Last Updated By" />
                          <Column field="LastUpdatedDate" header="Last Updated Date" body={(r) => moment(r.LastUpdatedDate).format("DD MMM YYYY")} />
                          <Column field="LeadCreationDate" header="Lead Creation Date" body={(r) => moment(r.LeadCreationDate).format("DD MMM YYYY")} />

                          <Column field="CloseRemarks" header="Close Remarks (Win/Loss Reason)" />
                          <Column field="OwnerName" header="Owner" />
                          <Column field="LeadTags" header="Lead Tags" />

                          <Column field="Email" header="Email ID" />
                          <Column field="Phone" header="Phone" />
                          <Column field="Website" header="Website" />
                          <Column field="City" header="City" />
                          <Column field="Address" header="Address" />
                          <Column field="Country" header="Lead Country" />
                          <Column field="DOB" header="DOB" body={(r) => moment(r.DOB).format("DD MMM YYYY")} />
                          <Column field="AnniversaryDate" header="Anniversary Date" body={(r) => moment(r.AnniversaryDate).format("DD MMM YYYY")} />

                          {userUpdatePermission && (
                            <Column
                              header="Action"
                              rowEditor
                              headerClassName="hide-filter-icon"
                            />
                          )}
                        </DataTable>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="nav-latest-contact" role="tabpanel" aria-labelledby="nav-latest-contact-tab">...</div>
            <div class="tab-pane fade" id="nav-all-contact" role="tabpanel" aria-labelledby="nav-all-contact-tab">...</div>
          </div>

        </div>
      </div>
      <div
        className="modal fade"
        id="review-request"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Form Submitted Successfully. Now Sent the Review Request.
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Request to</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select
                    </option>
                    <option>Employee Review</option>
                    <option>Review</option>
                    <option>HR Review</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Add your Comment</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-primary">
                Sumbit
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default LeadManagementList;

